export default __webpack_public_path__ + "static/media/ban2.27b58db2.jpg";